module.exports = __webpack_public_path__ + "img/login-image-04b.9d904206.png";